module.exports = __webpack_public_path__ + "img/3839c95.png";